import Vue from 'vue'
import Router from 'vue-router'

import List from '@/components/main/list'
import Lists from '@/components/main/lists'
import Down from '@/components/main/down'
import Login from '@/components/main/login'




Vue.use(Router)

export default new Router({
  mode: 'history',
  bash: '/',
  routes: [
    {
      path: '/',
      component: Login
    },
    {
      path: '/list',
      name: 'List',
      component: List
    },
    {
      path: '/lists',
      name: 'Lists',
      component: Lists
    },
    {
      path: '/down',
      name: 'Down',
      component: Down
    },







    { path: '*', redirect: '/' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js